// Characters that carry no visible width. They are deleted outright rather than
// mapped to a space so that words pasted from rich text sources stay intact.
// Includes zero-width marks, soft hyphen, tab, and common bidirectional /
// format controls that can otherwise survive into stored values.
var invisibleRegex = /[\u0009\u00ad\u061c\u200b-\u200f\u202a-\u202e\u2060\u2066-\u2069\ufeff]/g; // eslint-disable-line no-control-regex
var asciiByChar = {
    // Single quotes
    "\u2018": "'",
    "\u2019": "'",
    "\u201a": "'",
    "\u201b": "'",
    "\u2032": "'",
    "\u2039": "'",
    "\u203a": "'",
    // Double quotes
    "\u201c": '"',
    "\u201d": '"',
    "\u201e": '"',
    "\u201f": '"',
    "\u2033": '"',
    "\u00ab": '"',
    "\u00bb": '"',
    // Dashes and hyphens
    "\u2010": "-",
    "\u2011": "-",
    "\u2012": "-",
    "\u2013": "-",
    "\u2014": "-",
    "\u2015": "-",
    "\u2212": "-",
    // Ellipsis
    "\u2026": "...",
    // Spaces
    "\u00a0": " ",
    "\u2000": " ",
    "\u2001": " ",
    "\u2002": " ",
    "\u2003": " ",
    "\u2004": " ",
    "\u2005": " ",
    "\u2006": " ",
    "\u2007": " ",
    "\u2008": " ",
    "\u2009": " ",
    "\u200a": " ",
    "\u202f": " ",
    "\u205f": " ",
    "\u3000": " ",
    // Other
    "\u2022": "*",
    "\u00b7": ".",
    "\u2044": "/", // fraction slash
};
// Safe to interpolate directly into a character class because every key is a
// non-ASCII codepoint, so none of them are regex metacharacters.
var punctuationRegex = new RegExp("[".concat(Object.keys(asciiByChar).join(""), "]"), "g");
/**
 * Normalizes smart punctuation and alternate space characters to their ASCII
 * equivalents, and removes zero-width, soft-hyphen, tab, and bidirectional /
 * format-control characters. Alphabetic characters with diacritics
 * (é, ü, ñ, ...) are left unchanged.
 */
export var replacePunctuationWithAscii = function (value) {
    if (!value) {
        return value;
    }
    return value
        .replace(invisibleRegex, "")
        .replace(punctuationRegex, function (char) { var _a; return (_a = asciiByChar[char]) !== null && _a !== void 0 ? _a : char; });
};
//# sourceMappingURL=data:application/json;base64,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